import type { IconSvgObject } from './types';

const FlashOffIcon: IconSvgObject = [
  ["path", { d: "M10 12.9998H4.5L8.5 8.5M14 10.985V2L10.1136 6.5M14.0008 11.0002H19.5008L17.5 13.5M10.0008 13.015V22L15.5 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlashOffIcon;
